// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * The following are shared across all platforms and apps
 */
/**
 * The following are shared across all platforms and apps
 */
.app-footer {
  background-color: #f4f4f4;
  height: 80px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  font-family: "OpenSans-Regular";
}
.app-footer a {
  cursor: pointer;
}

.map-btn {
  width: 48px;
  height: 48px;
  font-size: 14px;
}
@media (max-width: 560px) {
  .map-btn {
    width: 36px;
    height: 36px;
  }
}

.divider {
  height: 16px;
  width: 2px;
  background-color: var(--undp-jtf-btn-dark-color);
}

.buttons {
  position: absolute;
  bottom: 24px;
  right: 8px;
}
.buttons button {
  background-color: var(--undp-jtf-accent-color);
  border-color: var(--undp-jtf-accent-color);
}

.sidebar-overlay {
  position: fixed;
  top: 65px;
  left: 0;
  width: 100vw;
  height: calc(100vh - 65px);
  background: rgba(0, 0, 0, 0.35);
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 9998;
  pointer-events: none;
}
.sidebar-overlay.active {
  opacity: 1;
  pointer-events: all;
}
@media (max-width: 992px) {
  .sidebar-overlay {
    top: 0;
    height: 100vh;
    z-index: 10000;
  }
}

.post-detail-container {
  position: fixed;
  top: 65px;
  right: 0;
  width: 750px;
  max-width: 90vw;
  height: calc(100vh - 65px);
  background: #f8f9fa;
  box-shadow: -8px 0 32px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  overflow-y: auto;
  transform: translateX(100%);
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 9999;
  padding: 0;
  background: #f8f9fa;
  box-shadow: -8px 0 32px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  overflow-y: auto;
  transform: translateX(100%);
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 9999;
  padding: 0;
  /* Asegurar que el contenido interno sea visible */
  /* Contenido interno con padding */
  /* Responsive breakpoints */
  /* Scrollbar personalizado */
}
@media (max-width: 992px) {
  .post-detail-container {
    top: 0;
    height: 100vh;
    z-index: 10001;
  }
}
.post-detail-container.active {
  transform: translateX(0);
}
.post-detail-container ::ng-deep eview-post-detail {
  display: block;
  width: 100%;
  height: 100%;
}
.post-detail-container ::ng-deep .card-body {
  margin: 0;
  border-radius: 0;
  box-shadow: none;
  background: transparent;
  padding: 0;
}
.post-detail-container ::ng-deep .card-body > * {
  background: white;
  margin-bottom: 12px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.post-detail-container ::ng-deep .card-body > *:first-child {
  margin-top: 0;
  border-radius: 0;
}
@media (max-width: 480px) {
  .post-detail-container {
    width: 100vw;
    max-width: 100vw;
  }
}
@media (min-width: 481px) and (max-width: 768px) {
  .post-detail-container {
    width: 85vw;
  }
}
@media (min-width: 769px) and (max-width: 1024px) {
  .post-detail-container {
    width: 70vw;
  }
}
@media (min-width: 1025px) and (max-width: 1440px) {
  .post-detail-container {
    width: 700px;
  }
}
@media (min-width: 1441px) {
  .post-detail-container {
    width: 750px;
  }
}
.post-detail-container::-webkit-scrollbar {
  width: 6px;
}
.post-detail-container::-webkit-scrollbar-track {
  background: transparent;
}
.post-detail-container::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.post-detail-container::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

.map-height {
  height: 91vh;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.form-filter {
  width: -moz-fit-content;
  width: fit-content;
  margin: 0px auto;
}

.filter-modal-header {
  align-items: flex-start;
  gap: 0.75rem;
}
.filter-modal-header__text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.2rem;
  flex: 1;
  min-width: 0;
  padding-right: 0.5rem;
}
.filter-modal-header .modal-title {
  line-height: 1.3;
}
.filter-modal-header__subtitle {
  display: block;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.35;
  opacity: 0.75;
}
.filter-modal-header .close {
  margin: 0;
  padding: 0.25rem 0.5rem;
  align-self: flex-start;
  flex-shrink: 0;
}

.map-height .buttons {
  right: 88px;
  bottom: 76px;
  width: 80px;
}
.map-height .map-buttons {
  border: 1px solid var(--undp-jtf-primary-color);
  border-radius: 10px;
  padding-top: 12px;
}
.map-height .map-buttons .text-center {
  margin: 5px;
}
.map-height .map-buttons .text-center .label-center {
  font: normal normal normal 14px/16px "OpenSans-Light";
  color: var(--undp-jtf-primary-color);
  text-align: center !important;
  margin-top: 10px;
}

@media (max-width: 560px) {
  .map-height .buttons {
    right: 16px !important;
    bottom: 25px;
    width: 54px !important;
  }
}
@media (max-width: 992px) {
  .map-height .buttons {
    right: 12px;
    bottom: 25px;
    width: 64px;
  }
  .map-height .map-buttons {
    border: 1px solid var(--undp-jtf-primary-color);
    border-radius: 10px;
    padding-top: 12px;
  }
  .map-height .map-buttons .text-center {
    margin: 5px;
  }
  .map-height .map-buttons .text-center .label-center {
    font: normal normal normal 11px/11px "OpenSans-Light";
    color: var(--undp-jtf-primary-color);
    text-align: center !important;
    margin-top: 10px;
  }
}
.map-dashboard-landing {
  position: relative;
  z-index: 1;
  width: 100%;
}

.about-us-body-container {
  display: flex;
  flex-direction: row;
  background-color: #003770;
  color: #fff;
  padding: 4rem 0;
  font-family: "OpenSans-Regular";
  position: relative;
}
.about-us-body-container .img-dot {
  position: absolute;
  z-index: 100;
  top: 0;
  width: 8%;
}
.about-us-body-container .section-title {
  font: normal normal bold 24px/32px "OpenSans-Regular";
}
.about-us-body-container .section-body {
  display: inline-block;
  margin-top: 25px;
  font: normal normal normal 14px/28px "OpenSans-Regular";
  text-align: justify;
}
.about-us-body-container .alerts-section {
  margin-bottom: 30px;
}
.about-us-body-container .btn-contact-us {
  color: #fff;
  background-color: var(--undp-jtf-btn-dark-color);
  margin-left: 20px;
  font-family: "OpenSans-Bold";
  padding: 7px 35px;
}
.about-us-body-container .section-read-more-link {
  margin-top: 3rem;
  display: inline-block;
}
.about-us-body-container .section-read-more-link a {
  color: #fff;
  text-decoration: none;
  font: normal normal normal 18px/24px "OpenSans-Regular";
}
.about-us-body-container .section-read-more-link a:hover {
  color: #fff;
  text-decoration: none;
  cursor: pointer;
}
.about-us-body-container .left-block-image {
  max-width: 42%;
}
@media (max-width: 680px) {
  .about-us-body-container .left-block-image {
    display: flex;
    max-width: 100%;
    justify-content: center;
  }
}
@media (max-width: 390px) {
  .about-us-body-container .left-block-image {
    max-width: 90%;
  }
}
.about-us-body-container .left-block-image img {
  box-shadow: 12px 12px #8db4da;
  border-radius: 78px;
}
.about-us-body-container .right-block {
  max-width: 58%;
  flex: 0 0 58%;
  padding-left: 4rem;
}
@media (max-width: 680px) {
  .about-us-body-container .right-block {
    max-width: 100%;
    margin-top: 30px;
    padding-right: 4rem;
  }
}

.about-us-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
@media (max-width: 680px) {
  .about-us-row {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

.footer-container {
  display: flex;
  flex-direction: row;
  background-color: #f4f4f4;
  color: var(--undp-jtf-primary-color);
  padding: 0rem 40px 2rem 40px;
}
.footer-container .left-block {
  padding: 3rem 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.footer-container .left-block:after {
  content: " ";
  position: absolute;
  border-left: 1px var(--undp-jtf-primary-color) solid;
  top: 20%;
  right: 0;
  height: 75%;
  margin-top: auto;
  margin-bottom: auto;
}
.footer-container .left-block .section-title {
  font: normal normal bold 30px/39px "OpenSans-Regular";
}
.footer-container .left-block .section-body {
  display: inline-block;
  margin-top: 25px;
  font: normal normal normal 14px/28px "OpenSans-Regular";
  text-align: justify;
}
.footer-container .left-block .section-read-more-link {
  margin-top: 3rem;
  display: inline-block;
}
.footer-container .left-block .section-read-more-link a {
  color: #fff;
  text-decoration: none;
  background-color: #003770;
  padding: 1em 2em;
  border-radius: 8px;
}
.footer-container .left-block .section-read-more-link a:hover {
  color: #fff;
  text-decoration: none;
  opacity: 0.9;
}
.footer-container .right-block {
  padding: 3rem 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.footer-container .right-block:after {
  content: " ";
  position: absolute;
  border-left: 1px var(--undp-jtf-primary-color) solid;
  top: 20%;
  right: 0;
  height: 75%;
  margin-top: auto;
  margin-bottom: auto;
}
.footer-container .right-block .section-title {
  font: normal normal bold 30px/39px "OpenSans-Regular";
}
.footer-container .right-block .section-body {
  display: inline-block;
  margin-top: 25px;
  font: normal normal normal 14px/28px "OpenSans-Regular";
  text-align: justify;
}
.footer-container .right-block .section-read-more-link {
  margin-top: 6.4rem;
  margin-right: 3em;
  display: inline-block;
}
.footer-container .right-block .section-read-more-link a {
  color: #fff;
  text-decoration: none;
  background-color: #003770;
  padding: 1em 2em;
  border-radius: 8px;
}
.footer-container .right-block .section-read-more-link a:hover {
  color: #fff;
  text-decoration: none;
  opacity: 0.9;
}

.custom-ui {
  color: var(--undp-jtf-primary-color);
}

eview-gmap {
  width: 100%;
  max-width: 100vw;
  box-sizing: border-box;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./libs/scss/_index.scss","webpack://./apps/hybrid-app/src/app/features/map-page/components/map-page.component.scss","webpack://./apps/hybrid-app/src/scss/_variables.scss"],"names":[],"mappings":"AAAA;;EAAA;AAAA;;EAAA;ACGA;EACE,yBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,+BCNqB;ADUvB;AAFE;EACE,eAAA;AAIJ;;AAAA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAGF;AADE;EALF;IAMI,WAAA;IACA,YAAA;EAIF;AACF;;AAFA;EACE,YAAA;EACA,UAAA;EACA,gDAAA;AAKF;;AAFA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;AAKF;AAJE;EACE,8CAAA;EACA,0CAAA;AAMJ;;AADA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,0BAAA;EACA,+BAAA;EACA,UAAA;EACA,6BAAA;EACA,aAAA;EACA,oBAAA;AAIF;AAFE;EACE,UAAA;EACA,mBAAA;AAIJ;AADE;EAjBF;IAkBI,MAAA;IACA,aAAA;IACA,cAAA;EAIF;AACF;;AADA;EACE,eAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,0BAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,uDAAA;EACA,aAAA;EACA,UAAA;EAOA,mBAAA;EACA,0CAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,uDAAA;EACA,aAAA;EACA,UAAA;EAMA,kDAAA;EAOA,kCAAA;EAqBA,2BAAA;EAsBA,4BAAA;AAtDF;AAdE;EAhBF;IAiBI,MAAA;IACA,aAAA;IACA,cAAA;EAiBF;AACF;AAPE;EACE,wBAAA;AASJ;AALE;EACE,cAAA;EACA,WAAA;EACA,YAAA;AAOJ;AAHE;EACE,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,UAAA;AAKJ;AAHI;EACE,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yCAAA;AAKN;AAHM;EACE,aAAA;EACA,gBAAA;AAKR;AACE;EA/DF;IAgEI,YAAA;IACA,gBAAA;EAEF;AACF;AAAE;EApEF;IAqEI,WAAA;EAGF;AACF;AADE;EAxEF;IAyEI,WAAA;EAIF;AACF;AAFE;EA5EF;IA6EI,YAAA;EAKF;AACF;AAHE;EAhFF;IAiFI,YAAA;EAMF;AACF;AAHE;EACE,UAAA;AAKJ;AAFE;EACE,uBAAA;AAIJ;AADE;EACE,8BAAA;EACA,kBAAA;AAGJ;AADI;EACE,8BAAA;AAGN;;AACA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;AAEF;;AAAA;EACE,uBAAA;EAAA,kBAAA;EACA,gBAAA;AAGF;;AAEA;EACE,uBAAA;EACA,YAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,OAAA;EACA,YAAA;EACA,qBAAA;AACJ;AAEE;EACE,gBAAA;AAAJ;AAGE;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;AADJ;AAIE;EACE,SAAA;EACA,uBAAA;EACA,sBAAA;EACA,cAAA;AAFJ;;AAME;EACE,WAAA;EACA,YAAA;EACA,WAAA;AAHJ;AAKE;EACE,+CAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;AAII;EACE,WAAA;AAFN;AAGM;EACE,qDAAA;EACA,oCAAA;EACA,6BAAA;EACA,gBAAA;AADR;;AAOA;EAEI;IACE,sBAAA;IACA,YAAA;IACA,sBAAA;EALJ;AACF;AASA;EAEI;IACE,WAAA;IACA,YAAA;IACA,WAAA;EARJ;EAUE;IACE,+CAAA;IACA,mBAAA;IACA,iBAAA;EARJ;EASI;IACE,WAAA;EAPN;EAQM;IACE,qDAAA;IACA,oCAAA;IACA,6BAAA;IACA,gBAAA;EANR;AACF;AAYA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;AAVF;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,+BC3RqB;ED4RrB,kBAAA;AAXF;AAYE;EACE,kBAAA;EACA,YAAA;EACA,MAAA;EACA,SAAA;AAVJ;AAYE;EACE,qDAAA;AAVJ;AAYE;EACE,qBAAA;EACA,gBAAA;EACA,uDAAA;EACA,mBAAA;AAVJ;AAYE;EACE,mBAAA;AAVJ;AAYE;EACE,WAAA;EACA,gDAAA;EACA,iBAAA;EACA,4BCrTgB;EDsThB,iBAAA;AAVJ;AAYE;EACE,gBAAA;EACA,qBAAA;AAVJ;AAWI;EACE,WAAA;EACA,qBAAA;EACA,uDAAA;AATN;AAUM;EACE,WAAA;EACA,qBAAA;EACA,eAAA;AARR;AAYE;EACE,cAAA;AAVJ;AAYI;EAHF;IAII,aAAA;IACA,eAAA;IACA,uBAAA;EATJ;AACF;AAWI;EATF;IAUI,cAAA;EARJ;AACF;AAUI;EACE,6BAAA;EACA,mBAAA;AARN;AAYE;EAGE,cAAA;EACA,aAAA;EACA,kBAAA;AAZJ;AAcI;EAPF;IAQI,eAAA;IACA,gBAAA;IACA,mBAAA;EAXJ;AACF;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAZF;AAcE;EALF;IAMI,sBAAA;IACA,uBAAA;IACA,mBAAA;EAXF;AACF;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,oCAAA;EACA,4BAAA;AAXF;AAYE;EACE,kBAAA;EAEA,aAAA;EACA,sBAAA;EACA,8BAAA;AAXJ;AAYI;EACE,YAAA;EACA,kBAAA;EACA,oDAAA;EACA,QAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AAVN;AAYI;EACE,qDAAA;AAVN;AAYI;EACE,qBAAA;EACA,gBAAA;EACA,uDAAA;EACA,mBAAA;AAVN;AAYI;EACE,gBAAA;EACA,qBAAA;AAVN;AAWM;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AATR;AAUQ;EACE,WAAA;EACA,qBAAA;EACA,YAAA;AARV;AAaE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAXJ;AAYI;EACE,YAAA;EACA,kBAAA;EACA,oDAAA;EACA,QAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AAVN;AAYI;EACE,qDAAA;AAVN;AAYI;EACE,qBAAA;EACA,gBAAA;EACA,uDAAA;EACA,mBAAA;AAVN;AAYI;EACE,kBAAA;EACA,iBAAA;EACA,qBAAA;AAVN;AAWM;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AATR;AAUQ;EACE,WAAA;EACA,qBAAA;EACA,YAAA;AARV;;AAgBA;EACE,oCAAA;AAbF;;AAiBA;EACE,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;AAdF","sourcesContent":["/**\n * The following are shared across all platforms and apps\n */\n\n// shared variables\n@import 'variables';\n\n// create/import other scss files or define as needed...\n","@import '@eview/scss/index';\n@import '../../../../scss/variables';\n\n.app-footer {\n  background-color: #f4f4f4;\n  height: 80px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  font-family: $primary-font-regular;\n\n  a {\n    cursor: pointer;\n  }\n}\n\n.map-btn {\n  width: 48px;\n  height: 48px;\n  font-size: 14px;\n\n  @media (max-width: 560px) {\n    width: 36px;\n    height: 36px;\n  }\n}\n.divider {\n  height: 16px;\n  width: 2px;\n  background-color: var(--undp-jtf-btn-dark-color );\n}\n\n.buttons {\n  position: absolute;\n  bottom: 24px;\n  right: 8px;\n  button {\n    background-color: var(--undp-jtf-accent-color);\n    border-color: var(--undp-jtf-accent-color);\n  }\n\n}\n\n.sidebar-overlay {\n  position: fixed;\n  top: 65px;\n  left: 0;\n  width: 100vw;\n  height: calc(100vh - 65px);\n  background: rgba(0, 0, 0, 0.35);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  z-index: 9998;\n  pointer-events: none;\n  \n  &.active {\n    opacity: 1;\n    pointer-events: all;\n  }\n  \n  @media (max-width: 992px) {\n    top: 0;\n    height: 100vh;\n    z-index: 10000;\n  }\n}\n\n.post-detail-container {\n  position: fixed;\n  top: 65px;\n  right: 0;\n  width: 750px;\n  max-width: 90vw;\n  height: calc(100vh - 65px);\n  background: #f8f9fa;\n  box-shadow: -8px 0 32px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n  overflow-y: auto;\n  transform: translateX(100%);\n  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  z-index: 9999;\n  padding: 0;\n  \n  @media (max-width: 992px) {\n    top: 0;\n    height: 100vh;\n    z-index: 10001;\n  }\n  background: #f8f9fa;\n  box-shadow: -8px 0 32px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n  overflow-y: auto;\n  transform: translateX(100%);\n  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  z-index: 9999;\n  padding: 0;\n  \n  &.active {\n    transform: translateX(0);\n  }\n  \n  /* Asegurar que el contenido interno sea visible */\n  ::ng-deep eview-post-detail {\n    display: block;\n    width: 100%;\n    height: 100%;\n  }\n  \n  /* Contenido interno con padding */\n  ::ng-deep .card-body {\n    margin: 0;\n    border-radius: 0;\n    box-shadow: none;\n    background: transparent;\n    padding: 0;\n    \n    > * {\n      background: white;\n      margin-bottom: 12px;\n      border-radius: 12px;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n      \n      &:first-child {\n        margin-top: 0;\n        border-radius: 0;\n      }\n    }\n  }\n  \n  /* Responsive breakpoints */\n  @media (max-width: 480px) {\n    width: 100vw;\n    max-width: 100vw;\n  }\n  \n  @media (min-width: 481px) and (max-width: 768px) {\n    width: 85vw;\n  }\n  \n  @media (min-width: 769px) and (max-width: 1024px) {\n    width: 70vw;\n  }\n  \n  @media (min-width: 1025px) and (max-width: 1440px) {\n    width: 700px;\n  }\n  \n  @media (min-width: 1441px) {\n    width: 750px;\n  }\n  \n  /* Scrollbar personalizado */\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n  \n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n  \n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n    \n    &:hover {\n      background: rgba(0, 0, 0, 0.3);\n    }\n  }\n}\n.map-height {\n  height: 91vh;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n.form-filter {\n  width: fit-content;\n  margin: 0px auto;\n  // left: 200px;\n  // position: relative;\n}\n\n.filter-modal-header {\n  align-items: flex-start;\n  gap: 0.75rem;\n\n  &__text {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.2rem;\n    flex: 1;\n    min-width: 0;\n    padding-right: 0.5rem;\n  }\n\n  .modal-title {\n    line-height: 1.3;\n  }\n\n  &__subtitle {\n    display: block;\n    font-size: 0.875rem;\n    font-weight: 400;\n    line-height: 1.35;\n    opacity: 0.75;\n  }\n\n  .close {\n    margin: 0;\n    padding: 0.25rem 0.5rem;\n    align-self: flex-start;\n    flex-shrink: 0;\n  }\n}\n.map-height {\n  .buttons {\n    right: 88px;\n    bottom: 76px;\n    width: 80px;\n  }\n  .map-buttons {\n    border: 1px solid var(--undp-jtf-primary-color);\n    border-radius: 10px;\n    padding-top: 12px;\n    .text-center {\n      margin: 5px;\n      .label-center {\n        font: normal normal normal 14px/16px $primary-font-medium;\n        color: var(--undp-jtf-primary-color);\n        text-align: center !important;\n        margin-top: 10px;\n      }\n    }\n  }\n}\n\n@media (max-width: 560px) {\n  .map-height {\n    .buttons {\n      right: 16px !important;\n      bottom: 25px;\n      width: 54px !important;\n    }\n  }\n}\n\n@media (max-width: 992px) {\n  .map-height {\n    .buttons {\n      right: 12px;\n      bottom: 25px;\n      width: 64px;\n    }\n    .map-buttons {\n      border: 1px solid var(--undp-jtf-primary-color);\n      border-radius: 10px;\n      padding-top: 12px;\n      .text-center {\n        margin: 5px;\n        .label-center {\n          font: normal normal normal 11px/11px $primary-font-medium;\n          color: var(--undp-jtf-primary-color);\n          text-align: center !important;\n          margin-top: 10px;\n        }\n      }\n    }\n  }\n}\n\n.map-dashboard-landing {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n}\n\n// Homepage About Us section\n.about-us-body-container {\n  display: flex;\n  flex-direction: row;\n  background-color: #003770;\n  color: #fff;\n  padding: 4rem 0;\n  font-family: $primary-font-regular;\n  position: relative;\n  .img-dot {\n    position: absolute;\n    z-index: 100;\n    top: 0;\n    width: 8%;\n  }\n  .section-title {\n    font: normal normal bold 24px/32px $primary-font-regular;\n  }\n  .section-body {\n    display: inline-block;\n    margin-top: 25px;\n    font: normal normal normal 14px/28px $primary-font-regular;\n    text-align: justify;\n  }\n  .alerts-section {\n    margin-bottom: 30px;\n  }\n  .btn-contact-us {\n    color: #fff;\n    background-color: var(--undp-jtf-btn-dark-color);\n    margin-left: 20px;\n    font-family: $primary-font-bold;\n    padding: 7px 35px;\n  }\n  .section-read-more-link {\n    margin-top: 3rem;\n    display: inline-block;\n    a {\n      color: #fff;\n      text-decoration: none;\n      font: normal normal normal 18px/24px $primary-font-regular;\n      &:hover {\n        color: #fff;\n        text-decoration: none;\n        cursor: pointer;\n      }\n    }\n  }\n  .left-block-image {\n    max-width: 42%;\n\n    @media (max-width: 680px) {\n      display: flex;\n      max-width: 100%;\n      justify-content: center;\n    }\n\n    @media (max-width: 390px) {\n      max-width: 90%;\n    }\n\n    img {\n      box-shadow: 12px 12px #8db4da;\n      border-radius: 78px;\n\n    }\n  }\n  .right-block {\n    //margin-left: 14px;\n    //right: -73px;\n    max-width: 58%;\n    flex: 0 0 58%;\n    padding-left: 4rem;\n\n    @media (max-width: 680px) {\n      max-width: 100%;\n      margin-top: 30px;\n      padding-right: 4rem;\n    }\n  }\n}\n\n.about-us-row {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n\n  @media (max-width: 680px) {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center\n  }\n}\n\n.footer-container {\n  display: flex;\n  flex-direction: row;\n  background-color: #f4f4f4;\n  color: var(--undp-jtf-primary-color);\n  padding: 0rem 40px 2rem 40px;\n  .left-block {\n    padding: 3rem 1rem;\n    // Code for right side border with height adjustment\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    &:after {\n      content: ' ';\n      position: absolute;\n      border-left: 1px  var(--undp-jtf-primary-color) solid;\n      top: 20%;\n      right: 0;\n      height: 75%;\n      margin-top: auto;\n      margin-bottom: auto;\n    }\n    .section-title {\n      font: normal normal bold 30px/39px $primary-font-regular;\n    }\n    .section-body {\n      display: inline-block;\n      margin-top: 25px;\n      font: normal normal normal 14px/28px $primary-font-regular;\n      text-align: justify;\n    }\n    .section-read-more-link {\n      margin-top: 3rem;\n      display: inline-block;\n      a {\n        color: #fff;\n        text-decoration: none;\n        background-color: #003770\t;\n        padding: 1em 2em;\n        border-radius: 8px;\n        &:hover {\n          color: #fff;\n          text-decoration: none;\n          opacity: 0.9;\n        }\n      }\n    }\n  }\n  .right-block {\n    padding: 3rem 1rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    &:after {\n      content: ' ';\n      position: absolute;\n      border-left: 1px  var(--undp-jtf-primary-color) solid;\n      top: 20%;\n      right: 0;\n      height: 75%;\n      margin-top: auto;\n      margin-bottom: auto;\n    }\n    .section-title {\n      font: normal normal bold 30px/39px $primary-font-regular;\n    }\n    .section-body {\n      display: inline-block;\n      margin-top: 25px;\n      font: normal normal normal 14px/28px $primary-font-regular;\n      text-align: justify;\n    }\n    .section-read-more-link {\n      margin-top: 6.4rem;\n      margin-right: 3em;\n      display: inline-block;\n      a {\n        color: #fff;\n        text-decoration: none;\n        background-color: #003770;\n        padding: 1em 2em;\n        border-radius: 8px;\n        &:hover {\n          color: #fff;\n          text-decoration: none;\n          opacity: 0.9;\n        }\n      }\n    }\n  }\n}\n\n\n.custom-ui {\n  color: var(--undp-jtf-primary-color);\n}\n\n// Estilos específicos para el mapa\neview-gmap {\n  width: 100%;\n  max-width: 100vw;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n","@import '@eview/scss/index';\n\n$primary-font: \"Montserrat\";\n$primary-font-bold: \"OpenSans-Bold\";\n$primary-font-medium: \"OpenSans-Light\";\n$primary-font-regular: \"OpenSans-Regular\";\n$primary-font-light: \"OpenSans-Light\";\n$primary-font-thin: \"OpenSans-Thin\";\n$secondary-font : \"Lato\";\n$secondary-font-bold: \"OpenSans-Bold\";\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
